<script>
import Textarea from '@wielink-application/shared/vue/components/form/input-only/textarea.vue'

export default Textarea;
</script>